module.exports = __webpack_public_path__ + "assets/print-memory-306ac4fb4239044f6f2498445fd22b0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/print-memory.jpg
// module id = 522
// module chunks = 1